import { conciergeClient } from 'src/api/concierge';

import { SupportHubEndpoints } from './constants';
import { GetZendeskSsoSuccessResponse, ZendeskSsoResponse } from './types';

export const getZendeskSsoUrl = async (): Promise<ZendeskSsoResponse> => {
    const { data: response } = await conciergeClient.get<GetZendeskSsoSuccessResponse>(
        SupportHubEndpoints.SSO
    );

    return response.data;
};
